import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  data: {
    searchText: null,
    duration: null,
    paymentStatus: null,
    state: null,
    customDate: null,
    timeDuration: null,
    startDate: null,
    endDate: null
  },
};

const saveTransactionLogsSearchFilterSlice = createSlice({
  name: "Save Transaction Logs Search Filters",
  initialState,
  reducers: {
    saveTransactionLogsSearchFilter(state, action) {
      state.data = action.payload;
    },
    resetSavedTransactionLogsSearchFilter(state) {
      state.data = initialState.data;
    },
  },
});

export const { saveTransactionLogsSearchFilter, resetSavedTransactionLogsSearchFilter } = saveTransactionLogsSearchFilterSlice.actions;
export default saveTransactionLogsSearchFilterSlice.reducer;
